export class Status {
  static readonly SAVED = new Status(
    'Status.Saved',
    'fa fa-check-circle home-ico-clr-green',
  );
  static readonly UNSAVED = new Status(
    'Status.Unsaved',
    'fa fa-exclamation-circle home-ico-clr-red',
  );
  static readonly SPINNER = new Status(
    'Status.Spinner',
    'fa fa-spinner fa-spin home-ico-clr-black',
  );
  static readonly NEXT_QUESTION = new Status(
    'Status.NextQuestion',
    'fa fa-spinner fa-spin home-ico-clr-black',
  );
  static readonly EXPIRED = new Status(
    'Status.Expired',
    'fa-solid fa-circle-exclamation',
    'form-exp exp-red',
  );
  static readonly NOT_EXPIRED = new Status(
    'Status.NotExpired',
    '',
    'home-dt-val text-medium fw-bold',
  );

  key: string;
  iconClass: string;
  otherClass: string;

  constructor(key: string, iconClass: string, otherClass = '') {
    this.key = key;
    this.iconClass = iconClass;
    this.otherClass = otherClass;
  }
}
